/**
 * Merges two objects together, with support for deeply nested values.
 */
export { default as deepMerge } from 'deepmerge';